module.exports = __webpack_public_path__ + "img/env_icon6.646617e0.png";